import { useRef, useState } from 'react'
import Text from '../../../core/utils/Text'
import { FaCheck, FaChevronDown } from 'react-icons/fa6'
import useClickOutside from '../../../core/hooks/useClickOutside'

const Select = ({
	value,
	onChange,
	options = [],
	placeholder = '',
	icon = null,
	singleSelect = false,
	template = null,
	className = '',
}) => {
	const ref = useRef()
	const [open, setOpen] = useState(false)
	useClickOutside(ref, () => setOpen(false))

	return (
		<div className={'relative z-[20]'} ref={ref}>
			<div
				className={
					`cursor-pointer dark:text-slate-200 text-xs 
          dark:bg-secondaryBg bg-slate-200 rounded flex items-center gap-5 px-4 py-2 min-h-[42px] lg:min-h-[52px] ` +
					className
				}
				onClick={() => setOpen((state) => !state)}
			>
				{icon ? <div className={'lg:min-w-[32px]'}>{icon}</div> : null}

				<div className={'min-w-[64px] lg:min-w-[92px]'}>
					{!!value ? template ? template(value) : <Text tid={value} /> : <Text tid={placeholder} />}
				</div>

				<div className={'lg:min-w-[32px] w-full flex justify-end'}>
					<FaChevronDown size={12} className={`${open ? 'rotate-180' : 'rotate-0'}`} />
				</div>
			</div>

			{open ? (
				<div
					className={`absolute z-[101] left-0 top-[44px] lg:top-[54px] w-full  max-h-[300px] text-xs p-3 rounded
                     dark:bg-secondaryBg bg-slate-100 overflow-y-auto overflow-x-hidden border-[1px] border-slate-500 border-opacity-10
                     `}
				>
					<div className={'flex flex-col gap-2'}>
						{options.map((op, idx) => {
							return (
								<div
									onClick={() => {
										if (value === op && !singleSelect) {
											onChange('')
										} else {
											onChange(op)
										}
										setOpen(false)
									}}
									className={
										`cursor-pointer p-3  hover:opacity-50 transition flex items-center justify-between ${idx + 1 !== options.length ? "border-b" : ""}`
									}
									key={op}
								>
									{template ? (
										template(op)
									) : (
										<>
											<Text tid={op} />
											{value === op ? <FaCheck size={18} className={'text-green-500'} /> : null}
										</>
									)}
								</div>
							)
						})}
					</div>
				</div>
			) : null}
		</div>
	)
}

export default Select
